<app-main-dialog (dismiss)="dismiss()">
  <div desktopTitle>
    {{ 'help.item' | translate }}
  </div>
  <form [formGroup]="formGroup">
    <h4>{{ 'item.name' | translate }}*</h4>
    <form formGroupName="name">
      <ion-item lines="none">
        <ion-input autocapitalize="on"
          formControlName="fi"></ion-input>
      </ion-item>
    </form>
    @if (typeS() === 'residence') {
      <app-select-site-button [items]="sites$ | async"
        [selectedSite]="selectedSite()"
        (selected)="selectSite($event)"></app-select-site-button>
    }
    <h4>{{ 'help.text' | translate }}</h4>
    <ion-item lines="none">
      <ion-textarea autocapitalize="on"
        formControlName="text"
        rows="5">
      </ion-textarea>
    </ion-item>
    <ion-item lines="none">
      <ion-toggle aria-label=""
        formControlName="public">
        {{ 'help.public' | translate }}
      </ion-toggle>
    </ion-item>
    @if (video().length > 0) {
      <app-carousel-images [items]="video()"></app-carousel-images>
    } @else {
      <app-take-video [name]="'instruction'"
        color="light"
        fill="clear"
        [title]="'help.video'"
        [multiline]="true"
        (imageUrl)="onVideoUrl($event)"></app-take-video>
    }
    <div class="or">{{ 'help.or' | translate }}</div>
    <ion-item button="true">
      <form method="post"
        enctype="multipart/form-data"
        class="input-form">
        <label class="input-label"
          for="file">
          <input id="file"
            type="file"
            name="file"
            (change)="selectFiles($event)" />
          @if (formGroup.get('url').value) {
            <ion-icon name="checkmark"></ion-icon>
            {{ 'general.selected' | translate }}
          } @else {
            {{ 'attachment.select' | translate }}
          }
        </label>
      </form>
    </ion-item>
    <div>
      <ion-button color="light"
        shape="round"
        [disabled]="formGroup.invalid"
        (click)="onSave()">
        {{ 'general.save' | translate }}
      </ion-button>
    </div>
  </form>
</app-main-dialog>